// extracted by mini-css-extract-plugin
module.exports = {"page_header":"ListPage_page_header__1dre8"};